import React from "react";
import TopBar from "./TopBar";
import ScheduleColumn from "./ScheduleColumn";
import SideColumn from "./SideColumn";
import ProviderPreviewBox from "./ProviderPreviewBox";
import { ErrorBoundary } from "../ErrorBoundary";
import config from "../../config";
import { useSearchParams } from "react-router-dom";
import { useProviderSchedule } from "../../hooks/useProviderSchedule";
import { useSchedulePreload } from "../../hooks/useSchedulePreload";
import { splitSchedule } from "../../utils/schedule";

interface HomePageProps {
  email: string;
}

const HomePage: React.FC<HomePageProps> = ({ email }) => {
  const [, setSearchParams] = useSearchParams();
  const isDevPreviewEnabled =
    config.AUTH_MODE === "iap" && config.ENVIRONMENT !== "production";

  const { status, errorMsg, appointments, enriched, now } =
    useProviderSchedule(email);
  useSchedulePreload({ enriched, now });
  const { upcoming, recent } = splitSchedule(enriched, now);

  const handleSelectPatient = (id: string, encounterId?: string) => {
    setSearchParams(
      encounterId
        ? { patient_id: id, encounter_id: encounterId }
        : { patient_id: id },
    );
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {isDevPreviewEnabled && <ProviderPreviewBox />}
      <TopBar email={email} onSelectPatient={handleSelectPatient} />

      <main className="flex-1 max-w-7xl w-full mx-auto w-full">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 p-6">
          <div className="lg:col-span-2">
            <ErrorBoundary>
              <ScheduleColumn
                upcoming={upcoming}
                now={now}
                status={status}
                errorMsg={errorMsg}
                isEmpty={appointments.length === 0}
                onSelectPatient={handleSelectPatient}
              />
            </ErrorBoundary>
          </div>
          <div>
            <SideColumn
              recentEncounters={recent}
              scheduleStatus={status}
              onSelectPatient={handleSelectPatient}
            />
          </div>
        </div>
      </main>
    </div>
  );
};

export default HomePage;
